import { Link } from 'react-router-dom';
import { DemoDockSkuId, demoDockSkus } from '../../components/DemoDock/Credits/creditExports';
import {
  useDemoDockCredits,
} from '../../components/DemoDock/Credits/credits';
import { DemoDockNav } from '../../components/DemoDock/DemoDockNav';
import './DemoDock.css';

function DemoDockSkus() {
  const credits = useDemoDockCredits();

  function handleChoosePlan(skuId: DemoDockSkuId) {
    credits.setSku(skuId);
  }

  return (
    <section className="page demo-dock-skus-page">
      <p className="project-detail-eyebrow">Demo Dock</p>
      <h1>Plans</h1>
      <p className="project-detail-lead">
        Choose the monthly credit allowance for this Demo Dock account.
      </p>
      <DemoDockNav />

      <div className="demo-dock-current-plan">
        <div>
          <p className="demo-dock-current-plan-label">Current plan</p>
          <p>
            {credits.sku.name}: {credits.remainingCredits} / {credits.totalCredits} credits left
          </p>
        </div>
        <Link to="/projects/demodock">Back to Demo Dock</Link>
      </div>

      <div className="demo-dock-sku-grid">
        {demoDockSkus.map((sku) => {
          const isCurrent = sku.id === credits.account.skuId;

          return (
            <article key={sku.id} className="demo-dock-sku-card">
              <div>
                <h2>{sku.name}</h2>
                <p className="demo-dock-sku-price">{sku.priceLabel}</p>
                <p>{sku.description}</p>
              </div>
              <p className="demo-dock-sku-credits">{sku.monthlyCredits} credits / month</p>
              <button
                type="button"
                disabled={isCurrent}
                onClick={() => handleChoosePlan(sku.id)}
              >
                {isCurrent ? 'Current plan' : sku.id === 'free' ? 'Switch to Free' : 'Upgrade'}
              </button>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default DemoDockSkus;
